import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'unblock-user-for-dependent');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'impersonated_users',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['dependentId'],
    },
    'chat',
    'blocked_users',
    { type: 'payload', selector: ['userId'] },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/unblock-user-for-dependent.js